import React, { useContext } from 'react';
import { MultiSelect } from 'primereact/multiselect';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { UserDetailsContext } from 'context/userDetailsContext';
import { LoaderComponent } from 'shared/LoaderComponent';
import { generateFullName } from 'utils/generateFullNameUtils';

const assignToItemTemplate = (option) => {
  return (
    <>
      {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
      {generateFullName(option)}
    </>
  );
};

function LeadAttorneyFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  const userList = userContext?.userList || [];
  const isFirmUserLoading = userContext?.isFirmUserLoading || false;

  return (
    <MultiSelect
      options={userList}
      name="leadAttorney"
      placeholder="All Attorneys"
      className="file-manager-select w-100"
      optionLabel={(v) => generateFullName(v)}
      optionValue="client_cognito_username"
      value={userList?.length > 0 ? fileManagerFilters?.leadAttorney : []}
      onChange={(e) => {
        onFilterChange(e);
        setSelectedRows([]);
      }}
      itemTemplate={assignToItemTemplate}
      panelFooterTemplate={isFirmUserLoading ? LoaderComponent : null}
      filter
      display="chip"
      disabled
    />
  );
}

export default LeadAttorneyFilter;
